module.exports = __webpack_public_path__ + "img/blue.2c179b8.svg";